import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomerVerificationComponent } from './customer-verification/customer-verification.component';
import { VideoCallingComponent } from './video-calling/video-calling.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgxCaptureModule } from 'ngx-capture';
import { RemoteUserScreenComponent } from './remote-user-screen/remote-user-screen.component';
import { WebSocketService } from './services/web-socket.service';
import { AgoraSdkConfigService } from "./services/agora-sdk-config.service";
import { NgImageSliderModule } from 'ng-image-slider';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { JwtHelperService, JWT_OPTIONS } from '@auth0/angular-jwt';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Datepicker
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { BsModalService } from 'ngx-bootstrap/modal';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
  declarations: [
    AppComponent,
    CustomerVerificationComponent,
    VideoCallingComponent,
    RemoteUserScreenComponent,
    TermsAndConditionsComponent,

  ],
  imports: [
    BrowserModule, NgImageSliderModule, NgSelectModule,
    BsDatepickerModule.forRoot(),
    AppRoutingModule, FormsModule, NgxCaptureModule, HttpClientModule, BrowserAnimationsModule
  ],
  providers: [BsModalService, WebSocketService, { provide: JWT_OPTIONS, useValue: JWT_OPTIONS }, JwtHelperService, DatePipe, AgoraSdkConfigService, { provide: LocationStrategy, useClass: PathLocationStrategy }],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
